import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Badge, Cell, Text } from '@vinted/web-ui';
import classNames from 'classnames';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { CatalogAttribute, WEB_CATALOG_ROOT_ALL_CODE } from 'constants/catalog';
import { selectCatalogEvent } from 'libs/common/event-tracker/events';
import { jsx as _jsx } from "react/jsx-runtime";

const CatalogsPanel = _ref => {
  let {
    selectedCategory,
    selectedCategoryId,
    triggerCatalogModal
  } = _ref;
  const translate = useTranslate();
  const {
    track
  } = useTracking();

  const parentCatalog = _objectSpread(_objectSpread({}, selectedCategory), {}, {
    code: WEB_CATALOG_ROOT_ALL_CODE,
    title: translate('header.main_navigation.catalogs.see_all')
  });

  const catalogList = [parentCatalog, ...selectedCategory.catalogs];

  const handleTitleClick = _ref2 => {
    let {
      id,
      title,
      landing
    } = _ref2;
    return event => {
      if (!landing) {
        const trakingEvent = selectCatalogEvent({
          catalogIds: [id],
          attributeId: CatalogAttribute.Navigation
        });
        track(trakingEvent);
        return;
      }

      event.preventDefault();
      triggerCatalogModal({
        catalogName: title,
        itemsRemaining: landing.itemsRemaining,
        imageUrl: landing.imageUrl
      });
    };
  };

  const renderCatalogItem = item => /*#__PURE__*/_jsx("div", {
    className: "catalog-dropdown__item",
    children: /*#__PURE__*/_jsx(Cell, {
      suffix: item.landing && /*#__PURE__*/_jsx(Badge, {
        theme: "primary",
        content: translate('common.new_badge')
      }),
      type: Cell.Type.Navigating,
      styling: Cell.Styling.Narrow,
      body: /*#__PURE__*/_jsx(Text, {
        truncate: true,
        children: item.title
      }),
      url: item.url,
      urlProps: {
        title: item.title
      },
      onClick: handleTitleClick(item),
      testId: "catalog-item-".concat(item.id),
      aria: {
        'aria-label': item.title
      }
    })
  }, item.id);

  return /*#__PURE__*/_jsx("div", {
    className: classNames('catalog-dropdown__category', {
      active: selectedCategory.id === selectedCategoryId
    }),
    children: catalogList.map(renderCatalogItem)
  });
};

export default CatalogsPanel;